import {ISkillState,ISKILLSActionCreator,ISkillActionTypes} from 'models/ISkillState';

const initialState:ISkillState[] = []

const reducer = (state = initialState, { type, payload }: ISKILLSActionCreator) => {
    switch (type) {
      case ISkillActionTypes.FETCH_SKILLS_LIST_REQUEST:
        return {
          ...state,
          data:[],
        }
      case ISkillActionTypes.FETCH_SKILLS_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;